/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteCustomerStatisticsInput = {
    id: string;
};
export type apiDeleteCustomerStatisticsMutationVariables = {
    input: DeleteCustomerStatisticsInput;
};
export type apiDeleteCustomerStatisticsMutationResponse = {
    readonly deleteCustomerStatistics: {
        readonly status: string;
    };
};
export type apiDeleteCustomerStatisticsMutation = {
    readonly response: apiDeleteCustomerStatisticsMutationResponse;
    readonly variables: apiDeleteCustomerStatisticsMutationVariables;
};



/*
mutation apiDeleteCustomerStatisticsMutation(
  $input: DeleteCustomerStatisticsInput!
) {
  deleteCustomerStatistics(input: $input) {
    status
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomerStatisticsPayload",
    "kind": "LinkedField",
    "name": "deleteCustomerStatistics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiDeleteCustomerStatisticsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiDeleteCustomerStatisticsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5df133f462db797c41789e91e8ce34ef",
    "id": null,
    "metadata": {},
    "name": "apiDeleteCustomerStatisticsMutation",
    "operationKind": "mutation",
    "text": "mutation apiDeleteCustomerStatisticsMutation(\n  $input: DeleteCustomerStatisticsInput!\n) {\n  deleteCustomerStatistics(input: $input) {\n    status\n  }\n}\n"
  }
};
})();
(node as any).hash = '30902ecf891e65d50e911cf075a7a79f';
export default node;
